import { Row, Col } from 'react-bootstrap';
import Image from 'next/image';
import useWindowSize from 'hooks/useWindowSize';
import Head from 'next/head';
import './styles.less';

const androidImage = '/static/images/auction-app/Android.png';
const appStore = '/static/images/auction-app/AppStore.svg';
const playStore = '/static/images/auction-app/PlayStore.svg';
const multiPhone = '/static/images/auction-app/MultiPhone.png';
const phoneHand = '/static/images/auction-app/PhoneHand.png';
const phoneGray = '/static/images/auction-app/PhoneGray.png';
const guyWithMobile = '/static/images/auction-app/GuyWithMobile.png';
const star = '/static/images/auction-app/Star.svg';

const AuctionApp = () => {
    const width = useWindowSize().width;
    const isDesktop = width >= 992;

    return (
        <div className="auction-app-container">
            <Head>
                <title>Online Storage Auction app | StorageTreasures</title>
                <meta name="description" content="Download our Online Storage Auction app today, create your free bidder registration, and start the hunt to bid, win and profit on StorageTreasure.com" />
                <meta name="keywords" content="online storage auction app, storage auction app" />
            </Head>

            <Row className="auction-app-row">
                <Col md={12} sm={12} xl={6}>
                    <h1>Online storage auction app</h1>
                    <p className="regular-text">
                        Hosting over 750,000 online storage auctions a year, StorageTreasures is the world’s largest, most trusted
                        online self storage auction platform. Download our free online storage auction app today. Discover and bid on
                        hundreds and thousands of storage auction treasures. Join our buyer community by registering and start the hunt to
                        bid, win and profit, on the go!
                    </p>
                    <Row>
                        <Col md={6} sm={6} xs={6} className="store-column first-store-col">
                            <a href="https://play.google.com/store/apps/details?id=com.opentech.storagetreasures" target="_blank">
                                <Image src={playStore} width={150} height={100} />
                            </a>
                        </Col>
                        <Col md={6} sm={6} xs={6} className="store-column first-store-col-right">
                            <a href="https://apps.apple.com/us/app/storagetreasures-auction-app/id6448074082" target="_blank">
                                <Image src={appStore} width={150} height={100} />
                            </a>
                        </Col>
                    </Row>
                </Col>
                <Col sm={12} md={12} xl={6} className="multi-phone-col">
                    <Image src={multiPhone} width={800} height={800}/>
                </Col>
            </Row>

            <Row className="auction-app-row">
                {!isDesktop ? (
                    <>
                        <Col md={12} sm={12} xl={6}>
                            <h2>Enhanced tools for faster bidding</h2>
                            <p className="regular-text">
                                Our auction app equips you with an intuitive and user-friendly interface, enabling you to place bids with a few taps,
                                right from the palm of your hand. Embrace efficiency as you bid and secure the treasures you’ve been searching for. <span>Bid Manager </span>
                                allows you to stay updated with all the auctions you are actively bidding on. Quickly search and save auctions with <span>AuctionWatch </span>
                                for updated bid prices, countdown timers and more.
                            </p>
                        </Col>
                        <Col md={12} sm={12} xl={6} className="phone-image-col">
                            <Image src={phoneHand} width={500} height={500} />
                        </Col>
                    </>
                ) : (
                    <>
                        <Col md={12} sm={12} xl={6} className="phone-image-col">
                            <Image src={phoneHand} width={500} height={500} />
                        </Col>
                        <Col md={12} sm={12} xl={6}>
                            <h2>Enhanced tools for faster bidding</h2>
                            <p className="regular-text">
                                Our auction app equips you with an intuitive and user-friendly interface, enabling you to place bids with a few taps,
                                right from the palm of your hand. Embrace efficiency as you bid and secure the treasures you’ve been searching for. <span>Bid Manager </span>
                                allows you to stay updated with all the auctions you are actively bidding on. Quickly search and save auctions with <span>AuctionWatch </span>
                                for updated bid prices, countdown timers and more.
                            </p>
                        </Col>
                    </>
                )}

            </Row>

            <Row className="auction-app-row">
                <Col md={12} sm={12} xl={6}>
                    <h2>Real-time notifications</h2>
                    <p className="regular-text">
                        Stay ahead in the auction game with real-time notifications. Keep informed of critical updates, ensuring you never miss an
                        essential moment during the bidding process. Whether it’s outbid alerts, winning bid and high bid notifications, we’ve got you covered.
                    </p>
                </Col>
                <Col md={12} sm={12} xl={6} className="phone-image-col">
                    <Image src={phoneGray} width={500} height={500} />
                </Col>
            </Row>

            <Row className="auction-app-row">
                {!isDesktop ? (
                    <>
                        <Col md={12} sm={12} xl={6}>
                            <h2>Enhanced on the go searching</h2>
                            <p className="regular-text">
                                Immerse yourself in a seamless mobile experience, granting you the power to explore and bid on storage units anytime, anywhere. Uncover
                                treasures during your daily commute, during breaks, or even while waiting in line. With our optimized search functionality and
                                effortless navigation, treasure-hunting has never been this accessible.
                            </p>
                        </Col>
                        <Col md={12} sm={12} xl={6} className="phone-image-col">
                            <Image src={guyWithMobile} width={500} height={500} />
                        </Col>
                    </>
                ) : (
                    <>
                        <Col md={12} sm={12} xl={6} className="phone-image-col">
                            <Image src={guyWithMobile} width={500} height={500} />
                        </Col>
                        <Col md={12} sm={12} xl={6}>
                            <h2>Enhanced on the go searching</h2>
                            <p className="regular-text">
                                Immerse yourself in a seamless mobile experience, granting you the power to explore and bid on storage units anytime, anywhere. Uncover
                                treasures during your daily commute, during breaks, or even while waiting in line. With our optimized search functionality and
                                effortless navigation, treasure-hunting has never been this accessible.
                            </p>
                        </Col>
                    </>
                )}
            </Row>
            <Row className="reviews-row">
                <Col className="reviews-title-col">
                    <p className="reviews-title">What people are saying</p>
                </Col>
                <Row>
                    <Col className="review-col" md={6} sm={6}>
                        <div className="review-container review-container-left">
                            <div className="stars-div">
                                {['1', '2', '3', '4', '5'].map((icon, index) => {
                                    return (
                                        <Image src={star} width={40} height={40} key={index} />
                                    );
                                })}
                            </div>
                            <div className="review-text">
                                <p>
                                    “I love the AuctionWatch and honestly the entire app experience. It is so easy to find auctions to bid on and
                                    searching on the go has been a game changer!”
                                </p>
                            </div>
                            <p className="review-name">- Felica</p>
                        </div>
                    </Col>
                    <Col className="review-col" md={6} sm={6}>
                        <div className="review-container review-container-right">
                            <div className="stars-div">
                                {['1', '2', '3', '4'].map((icon, index) => {
                                    return (
                                        <Image src={star} width={40} height={40} key={index} />
                                    );
                                })}
                            </div>
                            <div className="review-text">
                                <p>
                                    “I’ve been a StorageTreasures bidder for years and the Auction app has really changed my bidding strategy,
                                    love the real-time notifications!”
                                </p>
                            </div>
                            <p className="review-name">- Charles</p>
                        </div>
                    </Col>
                </Row>
            </Row>
            <Row className="auction-app-row auction-app-last-row">
                <Col md={12} sm={12} xl={6} className="android-col">
                    <Image src={androidImage} width={300} height={534} className="android-image" />
                </Col>
                <Col md={12} sm={12} xl={6}>
                    <p className="download-text">Download today</p>
                    <p className="download-description">
                        Hunt, bid and win on the go, by downloading our app available in both the Google Play and App Store.
                    </p>
                    <Row>
                        <Col md={6} sm={6} xs={6} className="last-store-column last-store-col">
                            <a href="https://play.google.com/store/apps/details?id=com.opentech.storagetreasures" target="_blank">
                                <Image src={playStore} width={150} height={100} />
                            </a>
                        </Col>
                        <Col md={6} sm={6} xs={6} className="last-store-column last-store-col-right">
                            <a href="https://apps.apple.com/us/app/storagetreasures-auction-app/id6448074082" target="_blank">
                                <Image src={appStore} width={150} height={100} />
                            </a>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default AuctionApp;
